export {
  LIST_ITEM_EXP,
  LIST_ITEM_INDEX_EXP,
  GLOBAL_UTIL_METHOD_ID,
  GLOBAL_MODULE_ID,
} from '@sunmao-ui/shared';

export const DIALOG_CONTAINER_ID = 'sunmao-ui-dialog-container';
